import { ILightRailItem } from '../../../types'
import {
  EpisodeListItemDate,
  EpisodeListItemDescription,
  EpisodeListItemDetailsWrap,
  EpisodeListItemLink,
  EpisodeListItemTitle,
  EpisodeListItemWrap,
} from './EpisodeListItem.style'
import { useProgramContext } from './ProgramContext'
import { ottRoot } from '../../Api'
import { EpisodeListItemThumbnailComp } from './EpisodeListItemThumbnailComp'
import { asset_type_enum } from '../../types'
import { useMemo } from 'react'

const EpisodeListItemLinkComp = ({
  href,
  children,
}: {
  href: string | false
  children: JSX.Element
}) =>
  href ? (
    <EpisodeListItemLink href={href}>{children}</EpisodeListItemLink>
  ) : (
    children
  )
export const EpisodeListItem = ({
  data,
}: {
  data: ILightRailItem
  isLast: boolean
}) => {
  const createDate = new Date(data.createDate * 1000)
  const { episode, seasonNumber, program } = useProgramContext()
  // const { setEpisode } = useProgramContext()

  const href = useMemo(() => {
    if (
      data.type === asset_type_enum.Trailer ||
      data.type === asset_type_enum.Movies
    ) {
      return `${ottRoot}/${data.id}`
    }
    if (episode !== data.id) {
      return `${ottRoot}/series/${data.metas?.SeriesID || program.id}/season/${
        data.metas?.SeasonNumber || seasonNumber
      }/${data.id}`
    }
    return false
  }, [
    data.id,
    data.metas?.SeasonNumber,
    data.metas?.SeriesID,
    data.type,
    episode,
    program.id,
    seasonNumber,
  ])

  return (
    <EpisodeListItemLinkComp href={href}>
      <EpisodeListItemWrap
        id={'ep' + data.id}
        data-episode-number={data.metas.EpisodeNumber}
      >
        <EpisodeListItemThumbnailComp
          name={data.name}
          images={data?.images}
          nowPlaying={episode === data.id}
        />
        <EpisodeListItemDetailsWrap itemProp={data.description}>
          <EpisodeListItemTitle>{data.name}</EpisodeListItemTitle>
          {data.description && (
            <EpisodeListItemDescription>
              {data.description}
            </EpisodeListItemDescription>
          )}
          <EpisodeListItemDate>
            {[
              createDate.getDate(),
              createDate.getMonth() + 1,
              createDate.getFullYear(),
            ].join('.')}
          </EpisodeListItemDate>
        </EpisodeListItemDetailsWrap>
      </EpisodeListItemWrap>
    </EpisodeListItemLinkComp>
  )
}
